import { FormulaLabel } from '../../../../models/formula.model';
import { TagModel } from '../../../../models/tag.model';

export interface FormValues {
    tags?: { label: string; value: string }[];
    labels?: FormulaLabel[];
}

export const getTagsInitialValues = (tags: TagModel[]): FormValues => ({
    tags: tags.map((tag) => ({
        value: tag.id,
        label: tag.name,
    })),
});

export const getMappedValues = (values: FormValues): string[] => {
    const tags = values.tags || [];
    return tags.map((tag) => tag.value);
};
